import axios from '../utils/axiosConfig';

const followAPI = {
  // Follow/Unfollow user
  toggleFollow: async (followingId) => {
    const response = await axios.post('/community/follow/toggle', { followingId });
    return response.data;
  },

  // Get followers with pagination
  getFollowers: async (userId, params = {}) => {
    const response = await axios.get(`/community/users/${userId}/followers`, { params });
    return response.data;
  },

  // Get following with pagination
  getFollowing: async (userId, params = {}) => {
    const response = await axios.get(`/community/users/${userId}/following`, { params });
    return response.data;
  },

  // Check follow status
  checkFollowStatus: async (userId) => {
    const response = await axios.get(`/community/users/${userId}/follow-status`);
    return response.data;
  },

  // Get mutual follows
  getMutualFollows: async (userId) => {
    // Note: This endpoint needs to be created in backend
    const response = await axios.get(`/community/users/${userId}/mutual-follows`);
    return response.data;
  },

  // Get follow suggestions
  getFollowSuggestions: async (params = {}) => {
    const response = await axios.get('/community/follow/suggestions', { params });
    return response.data;
  },
};

export default followAPI;